<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
                        <div class="modal-container" @click.stop>
            
                            <div class="modal-header" style="justify-content: flex-end;">
                                <button type="button" class="close" @click="$emit('closeModal')">
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
            
                            <div class="modal-body" v-if="marker">
                                <!-- {{coordinates}} -->
                                <h4>Total Vehicles : {{marker.length}}</h4>
                                <span style="color:red" v-if="marker.length == 0">No Vehicle Found!</span>

                                <l-map class="mt-2" style="height: 700px" :zoom="zoom" :center="center" v-if="center">
                                    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                                    <!-- <l-marker v-if="marker" :lat-lng="marker"></l-marker> -->
                                    <template v-if="marker.length > 0">
                                        <l-marker v-for="individualMarker in marker" :lat-lng="latLng(individualMarker.lat , individualMarker.lng)" >
                                            <l-popup>
                                                <div class="text-center">
                                                    <h5>Vehicle Details</h5>
                                                </div>
                                                <template v-if="!fields">
                                                    <div class="row">
                                                        <div class="col-4">
                                                            <b>Qrcode</b>
                                                        </div>
                                                        <div class="col-1">
                                                            <b>:</b>
                                                        </div>
                                                        <div class="col-7 w-100">
                                                            <span style="overflow-wrap: break-word;"><b>{{individualMarker.qrcode}}</b></span>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-2">
                                                        <div class="col-4">
                                                            <b>Engine No</b>
                                                        </div>
                                                        <div class="col-1">
                                                            <b>:</b>
                                                        </div>
                                                        <div class="col-7 w-100">
                                                            <b style="overflow-wrap: break-word;">{{individualMarker.engine_no}}</b>
                                                        </div>
                                                    </div>

                                                    <div class="row mt-2">
                                                        <div class="col-4">
                                                            <b>Lat</b>
                                                        </div>
                                                        <div class="col-1">
                                                            <b>:</b>
                                                        </div>
                                                        <div class="col-7 w-100">
                                                            <b style="overflow-wrap: break-word;">{{individualMarker.lat}}</b>
                                                        </div>
                                                        
                                                    </div>

                                                    <div class="row mt-2">
                                                        <div class="col-4">
                                                            <b>Lng</b>
                                                        </div>
                                                        <div class="col-1">
                                                            <b>:</b>
                                                        </div>
                                                        <div class="col-7 w-100">
                                                            <b style="overflow-wrap: break-word;">{{individualMarker.lng}}</b>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="row mt-2" v-for="field in fields" style="font-size:12px!important">
                                                        <div class="col-4">
                                                            <b>{{field.title}}</b>
                                                        </div>
                                                        <div class="col-1">
                                                            <b>:</b>
                                                        </div>
                                                        <div class="col-7 w-100" v-if="!field.date">
                                                            <b style="overflow-wrap: break-word;">{{individualMarker[field.variable]}}</b>
                                                        </div>
                                                        <div class="col-7 w-100" v-else>
                                                            <b style="overflow-wrap: break-word;">{{moment(individualMarker[field.variable]).format('DD MMM Y, HH:mm')}}</b>
                                                        </div>
                                                    </div>
                                                </template>
                                            </l-popup>
                                        </l-marker>
                                    </template>
                                </l-map>
                            </div>
                            <div class="modal-body text-center pt-5 pb-5" v-else>
                                <div class="spinner-border" role="status" style="width:10rem;height:10rem">
                                    <span class="sr-only" >Loading...</span>
                                </div>
                                <h4 class="mt-4">Initialising Map.....</h4>
                            </div>
                                
                        </div>
                    </div>
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                </div>
            </div>
        </div>
    </transition>
</template>
    
<script>
import { latLng, Icon } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import "leaflet/dist/images/marker-shadow.png";
import moment from 'moment'

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


export default {
    props : ['coordinates' , 'fields' , 'urlAPI'],
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup
    },
    data () {
        return {
            moment,
            latLng,
            zoom: 13,
            center: null,
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution:
                '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            marker : null
        }
    },
    mounted () {
        // setTimeout(this.loadAPI(), 500000);
        let vm = this;
        setTimeout(function () {
            vm.loadAPI()
        }, this.randomInt(1000,3000));
    },
    methods : {
        loadAPI () {
            this.$http.get(this.urlAPI)
            .then((resp) => {
                let coordinates = resp.data.data
                this.marker = coordinates ? coordinates : []
                // console.log(this.marker)
                let lat = coordinates[0] && coordinates[0].lat ? coordinates[0].lat : -6.14292183
                let lng = coordinates[0] && coordinates[0].lng ? coordinates[0].lng : 106.85673778
                this.center = [lat , lng]
            })
        }
    }
}
</script>

<style scoped>
    .custom-icon {
        background-color: white;
        padding: 7px;
        border: 1px solid #333;
        border-radius: 0 20px 20px 20px;
        box-shadow: 5px 3px 10px rgba(0, 0, 0, 0.2);
        text-align: center;
        width: auto !important;
        height: auto !important;
        margin: 0 !important;
    }

</style>
    